import { render, staticRenderFns } from "./ButtonRouterTo.vue?vue&type=template&id=58a61c4e&"
import script from "./ButtonRouterTo.vue?vue&type=script&lang=js&"
export * from "./ButtonRouterTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports